import React from 'react';
import './Footer.css';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-content">
        {/* Contact Us */}
        <div className="footer-section">
          <h3>Contact Us</h3>
          <p><FaMapMarkerAlt className="footer-icon" /> Nursery Address:<br />22064 64 Ave, Langley, BC, V2Y 2N8</p>
          <p><FaPhoneAlt className="footer-icon" /> 604-217-1351</p>
          <p><FaEnvelope className="footer-icon" /> info@peelsnativeplants.com</p>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/plants">Plants</a></li>
            <li><a href="/quote">Quote</a></li>
            <li><a href="/sales">Sales</a></li>
            <li><a href="/about">About Us</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>

        {/* Google Map */}
        <div className="footer-section">
          <h3>Find Us</h3>
          <div className="map-container">
            <iframe
              title="Peel Native Plants Location"
              src="https://www.google.com/maps?q=22064+64+Ave,+Langley,+BC,+V2Y+2N8&output=embed"
              width="100%"
              height="250"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>

      {/* Bottom Line */}
      <div className="footer-bottom">
        <p>Copyright © 2025 Peels Native Plants Ltd</p>
      </div>
    </footer>
  );
}

export default Footer;
